<script setup>
import { useGoogleAnalyticsPageView } from '~/composables/google-analytics'

const { $seoManager } = useNuxtApp()
const seo = $seoManager.generateSeoInfo({
  title: 'Cookies',
})
useHead(seo)
useGoogleAnalyticsPageView(seo.title)
</script>

<template>
  <SimplePageContent>
    <SimplePageTitle title="Cookies" />
    <div>
      <h1 class="my-5 text-2xl font-bold uppercase">
        Cookie Policy for Benchmark Minerals
      </h1>
      <p>
        This is the Cookie Policy for Benchmark Minerals, accessible from
        <NuxtLink
          to="/privacy"
          class="font-semibold hover:underline"
          no-prefetch
        >
          https://www.benchmarkminerals.com/privacy
        </NuxtLink>
      </p>
      <h4 class="mb-3 mt-8 text-xl font-bold">What Are Cookies</h4>
      <p>
        As is common practice with almost all professional websites this site
        uses cookies, which are tiny files that are downloaded to your computer,
        to improve your experience. This page describes what information they
        gather, how we use it and why we sometimes need to store these cookies.
        We will also share how you can prevent these cookies from being stored,
        however this may downgrade or ‘break’ certain elements of the sites
        functionality. For more general information on cookies see
        AboutCookies.org.
      </p>
      <h4 class="mb-3 mt-8 text-xl font-bold">How We Use Cookies</h4>
      <p>
        We use cookies for a variety of reasons detailed below. Unfortunately in
        most cases there are no industry standard options for disabling cookies
        without completely disabling the functionality and features they add to
        this site. It is recommended that you leave on all cookies if you are
        not sure whether you need them or not, in case they are used to provide
        a service that you use.
      </p>
      <h4 class="mb-3 mt-8 text-xl font-bold">Disabling Cookies</h4>
      <p>
        You can prevent the setting of cookies by adjusting the settings on your
        browser (see your browser Help for how to do this). Be aware that
        disabling cookies will affect the functionality of this and many other
        websites that you visit. Disabling cookies will usually result in also
        disabling certain functionality and features of this site. Therefore it
        is recommended that you do not disable cookies.
      </p>
      <h4 class="mb-3 mt-8 text-xl font-bold">
        The Cookies We Set (First Party Cookies)
      </h4>
      <ul class="ml-7 list-disc">
        <li>
          Account related cookies<br />
          If you create an account with us then we will use cookies for the
          management of the signup process and general administration. These
          cookies will usually be deleted when you log out however in some cases
          they may remain afterwards to remember your site preferences when
          logged out.
        </li>
        <li>
          Login related cookies<br />
          We use cookies when you are logged in so that we can remember this
          fact. This prevents you from having to log in every single time you
          visit a new page. These cookies are typically removed or cleared when
          you log out to ensure that you can only access restricted features and
          areas when logged in.
        </li>
      </ul>
      <h4 class="mb-3 mt-8 text-xl font-bold">Third Party Cookies</h4>
      <p class="mb-3">
        In some special cases we also use cookies provided by trusted third
        parties. The following section details which third party cookies you
        might encounter through this site.
      </p>
      <ul class="ml-7 list-disc">
        <li>
          This site uses Google Analytics which is one of the most widespread
          and trusted analytics solutions on the web for helping us to
          understand how you use the site and ways that we can improve your
          experience. These cookies may track things such as how long you spend
          on the site and the pages that you visit so we can continue to produce
          engaging content.<br />
          For more information on Google Analytics cookies, see the official
          Google Analytics page.
        </li>
        <li>
          This site uses Hotjar, a user journey analysis platform. These cookies
          may track user activity such as how long you spend on the site and
          interaction with the pages that you visit so we can continue to
          produce engaging content.<br />
          For more information on Hotjar cookies, see the official Hotjar page.
        </li>
        <li>
          This site uses HubSpot, a CRM system. These cookies may track things
          such as which pages and forms you visit and interact with; this allows
          us to improve the experience of our website.<br />
          For more information on HubSpot cookies, see the official HubSpot
          page.
        </li>
        <li>
          We also use social media buttons and/or plugins on this site that
          allow you to connect with your social network in various ways. For
          these to work, social media platforms will set cookies through our
          site which may be used to enhance your profile on their site or
          contribute to the data they hold for various purposes outlined in
          their respective privacy policies.
        </li>
      </ul>
      <h4 class="mb-3 mt-8 text-xl font-bold">More Information</h4>
      <p>
        If you are still looking for more information then you can contact us at
        <a
          class="font-semibold hover:underline"
          href="mailto:contact@benchmarkminerals.com"
        >
          contact@benchmarkminerals.com
        </a>
      </p>
    </div>
  </SimplePageContent>
</template>
